import axios from "axios";
import { useState } from "react";
import { hasuraHeadersFromSession } from "utils";
import { useSession } from "hooks";

export const useUploadForm = (url, extraHeaders = {}) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const { data: session, status } = useSession();

  const uploadForm = async (formData) => {
    setIsLoading(true);
    try {
      const response = await axios.post(url, formData, {
        headers: {
          // Don't manually set Content-Type; let axios handle it
          ...hasuraHeadersFromSession(session),
          ...extraHeaders,
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted =
            (progressEvent.loaded / progressEvent.total) * 50;
          setProgress(percentCompleted);
        },
        onDownloadProgress: (progressEvent) => {
          const percentCompleted =
            50 + (progressEvent.loaded / progressEvent.total) * 50;
          setProgress(percentCompleted);
        },
      });
      setIsSuccess(true);
      return response.data;
    } finally {
      setIsLoading(false);
    }
  };

  return { uploadForm, isSuccess, isLoading, progress };
};
